import { TYPES } from './reducer';

export const setCustomDistractorsProps = (
  customDistractorsProps,
  questionReference,
) => ({
  type: TYPES.SET_CUSTOM_DISTRACTORS_PROPS,
  payload: {
    questionReference,
    customDistractorsProps,
  },
});
